import { AccessibilityInfo, Animated, Platform } from 'react-native';

/** Pop corto al marcar; suave al sacar — mostrador, no confetti. */
export async function shouldReduceFavoriteMotion(): Promise<boolean> {
  try {
    return await AccessibilityInfo.isReduceMotionEnabled();
  } catch {
    return false;
  }
}

export function runFavoriteMarkedPop(scale: Animated.Value, reduceMotion: boolean): void {
  scale.setValue(1);
  if (reduceMotion) return;
  Animated.sequence([
    Animated.spring(scale, {
      toValue: 1.2,
      friction: 5,
      tension: 320,
      useNativeDriver: Platform.OS !== 'web',
    }),
    Animated.spring(scale, {
      toValue: 1,
      friction: 6,
      tension: 240,
      useNativeDriver: Platform.OS !== 'web',
    }),
  ]).start();
}

export function runFavoriteUnmarkedPulse(scale: Animated.Value, reduceMotion: boolean): void {
  if (reduceMotion) return;
  Animated.sequence([
    Animated.timing(scale, {
      toValue: 0.82,
      duration: 90,
      useNativeDriver: Platform.OS !== 'web',
    }),
    Animated.spring(scale, {
      toValue: 1,
      friction: 7,
      tension: 200,
      useNativeDriver: Platform.OS !== 'web',
    }),
  ]).start();
}

export function animateFavoriteStarSubdued(
  opacity: Animated.Value,
  subdued: boolean,
  reduceMotion: boolean,
): void {
  const target = subdued ? 0.38 : 1;
  if (reduceMotion) {
    opacity.setValue(target);
    return;
  }
  Animated.timing(opacity, {
    toValue: target,
    duration: 140,
    useNativeDriver: true,
  }).start();
}
